// extracted by mini-css-extract-plugin
export default {"container":"MyReview_container__Zu6wH","cardContainer":"MyReview_cardContainer__BzOQd","noContents":"MyReview_noContents__ZuPPD"};